<template>
  <div>
    <el-dialog title="选择商品" :visible="show" append-to-body width="1100px" @close="close">
      <div slot="title" class="fm-flex">
        <p>选择商品</p>
      </div>
      <CommoditySelect
        ref="selectRef"
        :show="show"
        :from="from"
        :selectList="selectList"
        @selectCommodity="selectCommodity"
      ></CommoditySelect>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "Fmerpv2WebCommoditySelectDialog",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    from: {
      // 来源，SaleOrder 销售单|PurchaseOrder 采购单 | CommodityLossOrder 报损单
      type: String,
      default: null,
      require: true,
    },
    selectList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  watch: {
    show: {
      handler(newVal) {
        setTimeout(() => {
          this.$refs.selectRef.initData();
        }, 10);
      },
      immediate: true,
    },
  },
  data() {
    return {};
  },

  mounted() {},

  methods: {
    close() {
      this.$emit("close");
    },
    selectCommodity(e) {
      this.$emit("selectCommodity", e);
    },
  },
};
</script>

<style lang="scss" scoped>
.commodityCard {
  float: left;
  width: 200px;
  margin-bottom: 10px;
}

.commodityCard >>> .el-card__body {
  padding: 10px;
}

.categoryItem {
  padding: 1em 0 1em 5px;
  margin-bottom: 2px;
  border-radius: 5px 0 0 5px;
}

.categoryItem-UnSelect {
  background: var(--fm-primary-lighter-color);
}

.categoryItem-Select {
  background: var(--fm-primary-color);
  color: white;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/CommoditySelectDialog.vue